export default {
  PROD: import.meta.env.MODE === "production",
  STAGING: import.meta.env.MODE === "staging",
  DEV: import.meta.env.DEV,
  VITE_MEDUSA_BACKEND_URL: import.meta.env.VITE_MEDUSA_BACKEND_URL,

  COUNTRIES: {
    AT: "Austria",
    BE: "Belgium",
    BG: "Bulgaria",
    BY: "Belarus",
    HR: "Croatia",
    CY: "Cyprus",
    CZ: "Czechia",
    DK: "Denmark",
    EE: "Estonia",
    FI: "Finland",
    FR: "France",
    GE: "Georgia",
    DE: "Germany",
    GR: "Greece",
    HU: "Hungary",
    IS: "Iceland",
    IE: "Ireland",
    IT: "Italy",
    LV: "Latvia",
    LI: "Liechtenstein",
    LT: "Lithuania",
    LU: "Luxembourg",
    MT: "Malta",
    NL: "Netherlands",
    NO: "Norway",
    PL: "Poland",
    PT: "Portugal",
    RO: "Romania",
    RU: "Russia",
    SK: "Slovakia",
    SI: "Slovenia",
    ES: "Spain",
    SE: "Sweden",
    CH: "Switzerland",
    GB: "United Kingdom",
  } as const,

  get COUNTRY_SELECT_ITEMS() {
    return Object.entries(this.COUNTRIES).map(([value, label]) => ({ value, label }));
  },

  filterStorageObjectKeys: [
    "orders_filter",
    "brand_orders_filter",
    "dashboard_filter",
  ] as const,
};
